import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { adminTenDlcClient } from '~/services';
import debounce from '~/utils/debounce';

export const useTcrBrandOptions = () => {
    const toasted = useToasted();
    const brandOptions = ref<{ label: string; value: string }[]>([]);
    const loadingBrands = ref(false);

    const searchBrands = debounce((query?: string) => {
        loadingBrands.value = true;

        adminTenDlcClient
            .getTcrBrands({ query })
            .then((response) => {
                brandOptions.value = response.data.data.map((brand) => ({
                    value: brand.brand_id,
                    label: null === brand.display_name ? brand.brand_id : `${brand.brand_id} - ${brand.display_name}`,
                }));
            })
            .catch((e) => {
                console.error(e);
                toasted.global.platform_error();
            })
            .finally(() => {
                loadingBrands.value = false;
            });
    }, 300);

    return { brandOptions, loadingBrands, searchBrands };
};
